import React from "react";
import { EmptyState, PortalLoading, StudentPageHeader, useStudentPortal } from "./studentPortalUtils";

function StudentTimetablePage() {
  const { data, loading, reload } = useStudentPortal("student-portal/timetable/");
  if (loading && !data) return <PortalLoading />;
  const slots = data?.slots || [];
  const grouped = slots.reduce((acc, slot) => {
    acc[slot.day] = acc[slot.day] || [];
    acc[slot.day].push(slot);
    return acc;
  }, {});
  return (
    <div className="container-fluid py-4">
      <StudentPageHeader title="My Timetable" subtitle={data?.class_group?.name || "Your weekly class timetable"} icon="bi-calendar2-week" actions={<button className="btn btn-light border" onClick={reload}>Refresh</button>} />
      {slots.length === 0 ? <div className="card border-0 shadow-sm"><EmptyState title="No timetable assigned" message="Your class timetable will appear after setup." /></div> : Object.entries(grouped).map(([day, rows]) => (
        <div className="card border-0 shadow-sm mb-3" key={day}>
          <div className="card-header bg-white fw-bold">{day}</div>
          <div className="table-responsive">
            <table className="table align-middle mb-0">
              <thead className="table-light"><tr><th>Period</th><th>Time</th><th>Subject</th><th>Teacher</th><th>Room</th></tr></thead>
              <tbody>{rows.map((slot) => <tr key={slot.id} className={slot.is_break ? "table-warning" : ""}><td>{slot.period}</td><td>{slot.period_time}</td><td className="fw-semibold">{slot.subject}</td><td>{slot.teacher || "-"}</td><td>{slot.room || "-"}</td></tr>)}</tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
}
export default StudentTimetablePage;
